import { PropsWithChildren } from 'react';

const PageContent = ({ children }: PropsWithChildren) => (
  <div className="relative w-full px-5 md:px-10">{children}</div>
);

export default PageContent;
